import {
  type V2AdminDemoFirstRunResetDto,
  type V2AdminDemoFirstRunStatusDto,
  v2AdminDemoFirstRunControllerReset,
  v2AdminDemoFirstRunControllerStatus
} from '@idc-forms/api-client'
import { V2AdminDemoFirstRunStatusSchema } from '@idc-forms/schemas/api-v2/admin-societies'
import { assertShape } from '@/shared/api/assert-shape'
import { bearer, v2RequestOptions } from '@/shared/api/v2-request'

/**
 * El «primer ingreso» de la cuenta de revisión de tiendas (ADR 0041).
 *
 * `status` responde 404 a quien no es visor de demo o a una cuenta que no es la de revisión, y esa
 * es la señal con la que la tarjeta decide si se dibuja: NO hay que traducirla a otra cosa.
 */
export const demoFirstRunV2Service = {
  status: async (accessToken: string, id: string): Promise<V2AdminDemoFirstRunStatusDto> => {
    const result = await v2AdminDemoFirstRunControllerStatus({
      ...v2RequestOptions,
      headers: bearer(accessToken),
      path: { id }
    })
    return assertShape(V2AdminDemoFirstRunStatusSchema, result.data)
  },

  reset: async (accessToken: string, id: string): Promise<V2AdminDemoFirstRunResetDto> => {
    const result = await v2AdminDemoFirstRunControllerReset({
      ...v2RequestOptions,
      headers: bearer(accessToken),
      path: { id }
    })
    return result.data
  }
}
